import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';

const ContentDisplay = ({content}: { content: string }) => {
  if (!content || content === '') {
    return null;
  }

  return (
    <div>
      <p className="content-display">
        <ReactMarkdown source={content} />
      </p>
    </div>
  );
};

export default ContentDisplay;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/ContentDisplay/index.tsx